// Components==============
import Button from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import './DeleteMemberModal.module.scss';
// =========================

export default function DeleteMemberModal({
  setModalIsOpen,
  member,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  member: ProjectMemberEntity;
}) {
  const translate = useTranslate();
  const { handleDeleteMember } = useContext(ProjectDetailsContext);

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <div styleName="wrapper">
        <img src="/images/trash.svg" alt="trash" />
        <h2>
          {translate('project.groupswork-popups.delete-user-popup.title1')}{' '}
          {member.user.first_name}{' '}
          {translate('project.groupswork-popups.delete-user-popup.title2')}
        </h2>
        <p>
          {translate('project.groupswork-popups.delete-user-popup.description')}
        </p>
        <div styleName="button-wrapper">
          <Button color="grey" onClick={() => setModalIsOpen(false)}>
            {translate('general.terms.cancel')}
          </Button>
          <Button
            onClick={() => {
              setModalIsOpen(false);
              handleDeleteMember(member.id);
            }}
            color="red"
          >
            {translate('general.terms.delete')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
